module.exports = __webpack_public_path__ + "static/media/image6.a07af4e9.jpeg";